import html2canvas from "html2canvas";
import React from "react";

import { useLocation } from "../../contexts/LocationContext";
import { useRace } from "../../contexts/RaceContext";
import { useYear } from "../../contexts/YearContext";
import { getData } from "../../data";
import Card from "../Card";
import SelectLocation from "../SelectLocation";
import SelectRace from "../SelectRace";
import SelectYear from "../SelectYear";
import styles from "./TextGraphic.module.css";

function stringToDivs(string) {
  return string.split(" ").map((w) => <div className={styles.word}>{w}</div>);
}

function getCount(race, year, location) {
  let data = getData();

  data = data.filter((d) => new Date(d.date).getFullYear() === year);

  if (race !== "all") {
    data = data.filter((d) => d.race === race);
  }

  if (location !== "US") {
    data = data.filter((d) => d.state === location);
  }

  return data.length;
}

const TextGraphic = () => {
  const printRef = React.useRef();

  const handleDownloadImage = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");

    if (typeof link.download === "string") {
      link.href = data;
      link.download = "image.jpg";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  const downLoadImage = async () => {
    await handleDownloadImage();
  };

  const race = useRace();
  const year = useYear();
  const location = useLocation();

  const count = getCount(race, year, location);

  return (
    <div className={styles.container} ref={printRef}>
      <Card
        downLoadImage={downLoadImage}
        message={`Police have Killed ${count} ${race} ${
          race !== "all" ? "people" : ""
        } in ${location} so far in ${year}`}
      >
        <div className={styles.content}>
          {stringToDivs("Police have Killed")}
          <div className={styles.count}>{count}</div>
          <div className={styles.word}>
            <SelectRace withLabel={false} />
          </div>
          {stringToDivs(`${race !== "all" ? "people" : ""} in`)}
          <div className={styles.word}>
            <SelectLocation withLabel={false} />
          </div>
          {stringToDivs("so far in")}
          <div className={styles.word}>
            <SelectYear withLabel={false} />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default TextGraphic;
